import React, { FC, Suspense } from 'react'

import { useTypedSelector } from '@hooks/common/useTypedSelector'

import { lazyImport } from '@utils/lazyImport'

const { Upsale } = lazyImport(
  () =>
    import(
      /*webpackChunkName: 'upsale'*/ '@components/Overlays/Upsale/Upsale'
    ),
  'Upsale'
)

export const LazyUpsale: FC = () => {
  const isOpened = useTypedSelector(
    (state) => state.overlays.upsale.isOpened
  )

  return (
    <>
      {isOpened && (
        <Suspense fallback={null}>
          <Upsale />
        </Suspense>
      )}
    </>
  )
}
